export default __webpack_public_path__ + "static/media/musicLogo.c2997267.webp";